import { ApiError, errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/** MFA status, disable and "sign out everywhere" for the settings page (#1501). */
export class SessionSecurityViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ status: null, loading: false, error: null, notice: null, signedOut: false });
        this.client = client;
    }
    async load() {
        this.setState({ loading: true, error: null });
        try {
            const status = await this.client.mfaStatus();
            this.setState({ loading: false, status });
        }
        catch (err) {
            this.setState({ loading: false, error: errorMessage(err, "Could not load security settings.") });
        }
    }
    /** Disables MFA with a TOTP code or, when `recovery` is true, a recovery code. */
    async disable(value, recovery = false) {
        const v = value.trim();
        if (!v) {
            this.setState({
                error: recovery
                    ? "Enter a recovery code to turn off two-step sign-in."
                    : "Enter your 6-digit code to turn off two-step sign-in.",
            });
            return false;
        }
        this.setState({ loading: true, error: null, notice: null });
        try {
            await this.client.mfaDisable(recovery ? { recoveryCode: v } : { code: v });
            const status = await this.client.mfaStatus();
            this.setState({ loading: false, status, notice: "Two-step sign-in is off." });
            return true;
        }
        catch (err) {
            const wrong = err instanceof ApiError && (err.status === 401 || err.code === "invalid_credentials");
            this.setState({
                loading: false,
                error: wrong ? "That code did not work." : errorMessage(err, "Could not turn off two-step sign-in."),
            });
            return false;
        }
    }
    async revokeAll() {
        this.setState({ loading: true, error: null, notice: null });
        try {
            await this.client.revokeAllSessions();
            this.setState({ loading: false, signedOut: true, status: null });
            return true;
        }
        catch (err) {
            this.setState({ loading: false, error: errorMessage(err, "Could not sign out everywhere.") });
            return false;
        }
    }
}
/** True for the 403 `mfa_required` answer of a privileged write after the grace period (#1501). */
export function isMfaRequiredError(err) {
    return err instanceof ApiError && err.status === 403 && err.code === "mfa_required";
}
//# sourceMappingURL=SessionSecurityViewModel.js.map